module["exports"] = [
  "#{city_prefix}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es/address/city.js
// module id = 1083
// module chunks = 0